import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_message_template_placeholder_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    message_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    placeholder_name: fromDatatype.VarcharDatatypeInterface;
    placeholder_code: fromDatatype.VarcharDatatypeInterface;
    placeholder_type: fromDatatype.VarcharDatatypeInterface;
    placeholder_source: fromDatatype.VarcharDatatypeInterface;
    default_value: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    message_template_line_guid:  fromDatatype.GuidDataFieldInterface;
    placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
    value_string: fromDatatype.VarcharDatatypeInterface;
    value_file: fromDatatype.VarcharDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime:fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    index: fromDatatype.IntegerDatatypeClass;
    printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;

 
}

export class bl_fi_generic_doc_message_template_placeholder_hdr_RowClass
  implements bl_fi_generic_doc_message_template_placeholder_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    message_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    placeholder_name: fromDatatype.VarcharDatatypeInterface;
    placeholder_code: fromDatatype.VarcharDatatypeInterface;
    placeholder_type: fromDatatype.VarcharDatatypeInterface;
    placeholder_source: fromDatatype.VarcharDatatypeInterface;
    default_value: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    message_template_line_guid:  fromDatatype.GuidDataFieldInterface;
    placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
    value_string: fromDatatype.VarcharDatatypeInterface;
    value_file: fromDatatype.VarcharDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime:fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    index: fromDatatype.IntegerDatatypeClass;
    printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
}